const NON_PRODUCTION_DOMAIN_PARTIALS = [
    'localhost',
    'preview.zocdoc.com',
    'staging.zocdoc.com',
    'zocdoccloud.net',
];

const INFERRED_HOSTNAME =
    typeof window !== 'undefined' ? window.location.hostname : '';

/**
 * To use this function in SSR, you must pass in the hostname explicitly
 * since it cannot be inferred via `window.location`.
 */
const isProduction = (hostname = INFERRED_HOSTNAME) =>
    NON_PRODUCTION_DOMAIN_PARTIALS.some((siteName) =>
        hostname.includes(siteName)
    ) === false;

const isPreview = (hostname = INFERRED_HOSTNAME) =>
    hostname.includes('preview');

export const shouldUseProductionSettings = (hostname) =>
    hostname ? isPreview(hostname) || isProduction(hostname) : false;
